import config from '@packages/common/config.js';

export function alicdnFormat(src, size) {
    if (!src) {
        return config.defaultImg;
    }
    const hasHost = src.startsWith('http');
    const isAlicdn = src.includes('img/ibank');
    if (size && isAlicdn) {
        let sizeStr = size;
        if (typeof size === 'number') {
            size -= size % 10;
            sizeStr = `${size}x${size}`;
        } else if (Array.isArray(size)) {
            sizeStr = `${size[0]}x${size[1] ?? size[0]}`;
        }
        const match = src.match(/\.\w+$/);
        const ext = match?.length ? match[0] : '';
        src = src.replace(/(\.\d+x\d+)?\.\w+$/, `.${sizeStr}${ext}`);
    }
    if (hasHost) {
        return src;
    } else {
        return config.alicdn + src;
    }
}
